import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AddApplicationService {
  public applicationAdded$ = new Subject<void>();
}
